// extracted by mini-css-extract-plugin
module.exports = {"cover":"hoverImage_cover__UHwk0"};